import { EBuilderChatActionTypes, TBuilderChatActions } from '../../actions/builderChat';
import { EConsultantCianChatActionTypes, TConsultantCianChatActions } from '../../actions/consultantCianChat';
import { IBuilderChatState } from '../../types/builderChatState';

const initialState: IBuilderChatState = {
  isOpened: false,
};

export function builderChatReducer(
  state: IBuilderChatState = initialState,
  action: TBuilderChatActions | TConsultantCianChatActions,
): IBuilderChatState {
  switch (action.type) {
    case EBuilderChatActionTypes.OpenChat:
      return {
        ...state,
        isOpened: true,
        chatContact: action.payload.chatContact,
        gaLabel: action.payload.gaLabel,
      };

    case EBuilderChatActionTypes.CloseChat:
      return {
        ...state,
        isOpened: false,
      };

    case EBuilderChatActionTypes.SetBuilderChatButtonClicked:
      return {
        ...state,
        isButtonClicked: true,
      };

    // Закрываем чат с застройщиком, если открывается чат с консультантом.
    case EConsultantCianChatActionTypes.OpenChat:
      if (action.payload) {
        return {
          ...state,
          isOpened: false,
        };
      }

      return state;

    default:
      return state;
  }
}
